import { gql } from "@/__generated__/gql";

export const UPDATE_CONTACT_INFO_MUTATION = gql(`
  mutation UpdateContactInfo(
    $userId: ID!
    $email: String!
    $phoneNumber: String!
  ) {
    updateUserContactInfoMutation(input: {
      userId: $userId
      email: $email
      phoneNumber: $phoneNumber
    }) {
      clientMutationId
      errors {
        title
        message
      }
    }
  }
`);
